export const aptSelectBundle = {
  header: {
    title: {
      ko: "공동 주택 관리 포털",
      en: "Apartment MGMT Portal",
      es: "Portal de gestion de apartamentos"
    },
    description: {
      ko: "운영 중인 아파트 단지를 지역별로 검색하고 관리하세요.",
      en: "Search and manage apartment complexes by region.",
      es: "Busque y gestione complejos de apartamentos por region."
    }
  },
  filter: {
    regionPlaceholder: { ko: "지역 선택", en: "Select Region", es: "Seleccionar region" },
    inputPlaceholder: {
      ko: "아파트명으로 검색",
      en: "Search by Apartment Name",
      es: "Buscar por nombre del apartamento"
    },
    searchButton: { ko: "검색", en: "Search", es: "Buscar" },
    all: { ko: "전체", en: "All", es: "Todos" },
    reset: { ko: "초기화", en: "Reset", es: "Restablecer" },
    apply: { ko: "검색 적용", en: "Apply Search", es: "Aplicar busqueda" },
    sido: { ko: "시/도", en: "City/Province", es: "Provincia/Ciudad" },
    sgg: { ko: "시/군/구", en: "City/County/District", es: "Ciudad/Condado/Distrito" },
    road: { ko: "도로명", en: "Road Name", es: "Nombre de la calle" }
  },
  empty: {
    defaultTitle: {
      ko: "지역을 선택하거나 아파트명을 검색해주세요.",
      en: "Please select a region or search by apartment name.",
      es: "Seleccione una region o busque por nombre del apartamento."
    },
    noResult: {
      ko: "조건에 맞는 단지가 없습니다.",
      en: "No apartment complexes found matching the conditions.",
      es: "No se encontraron complejos de apartamentos que coincidan con las condiciones."
    },
    resetLink: { ko: "필터 초기화하기", en: "Reset Filters", es: "Restablecer filtros" }
  }
}
